import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import PropTypes from "prop-types";

const Draggable = ({ id, path, node, isDisabled, children }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    data: { path, node },
    disabled: isDisabled,
  });
  const style = transform
    ? {
        transform: CSS.Translate.toString(transform),
      }
    : undefined;
  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {children}
    </div>
  );
};

Draggable.propTypes = {
  id: PropTypes.string.isRequired,
  path: PropTypes.string,
  node: PropTypes.object,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
};

export default Draggable;
